import React from 'react';
export function Terms() {
  return <div className="pt-10 pb-20" data-id="element-513" data-mp="11fc77tj1ddxj">
      <div className="bg-gray-50 py-16 mb-12" data-id="element-514" data-mp="3tp0mg01wleqe">
        <div className="container-custom" data-id="element-515" data-mp="3tpsi1avi3cgo">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-516" data-mp="3tmo4vo0256dv">
            Terms & Conditions
          </h1>
          <p className="text-gray-600" data-id="element-517" data-mp="79fyy4fh3n4u">Last Updated: January 2024</p>
        </div>
      </div>

      <div className="container-custom max-w-4xl" data-id="element-518" data-mp="c8j19h42jf94">
        <div className="prose prose-blue max-w-none text-gray-700" data-id="element-519" data-mp="c7r6g8iapljw">
          <h3 data-id="element-520" data-mp="g9l1o19q1xco">1. Acceptance of Terms</h3>
          <p data-id="element-521" data-mp="g8jitamgs6ke">
            By accessing and using the website of Brixen Consulting FZCO ("we,"
            "us," or "our"), you agree to comply with and be bound by these
            Terms and Conditions. If you do not agree to these terms, please do
            not use our services or website.
          </p>

          <h3 data-id="element-522" data-mp="2n2omjedokeg8">2. Scope of Services</h3>
          <p data-id="element-523" data-mp="2rz59w6d22os9">
            Brixen Consulting FZCO provides corporate services, business
            support, and commercial brokerage/introduction services. Our
            services include company formation assistance, documentation
            support, and commercial introductions.
          </p>

          <h3 data-id="element-524" data-mp="1tj1p48zmlykh">3. No Legal or Financial Advice</h3>
          <p data-id="element-525" data-mp="1tjt9soroqbvz">
            <strong data-id="element-526" data-mp="1thgw4nsymnoq">Disclaimer:</strong> We are a corporate services provider
            and commercial broker. We do not provide regulated financial advice,
            banking services, or legal advice. Any information provided by us is
            for general guidance and does not constitute professional legal or
            financial advice. Clients are encouraged to seek independent legal
            or financial counsel where appropriate.
          </p>

          <h3 data-id="element-527" data-mp="287o2i55p0g92">4. Third-Party Services & Fees</h3>
          <p data-id="element-528" data-mp="11sdp509ouz8e">
            Our services may involve coordination with third parties, including
            but not limited to government authorities, free zone authorities,
            banks, and other service providers. Fees charged by these third
            parties are separate from our professional fees and are the
            responsibility of the client. We are not responsible for delays or
            decisions made by third-party authorities.
          </p>

          <h3 data-id="element-529" data-mp="p9i24whfzia0">5. Client Responsibilities</h3>
          <p data-id="element-530" data-mp="tb3bw8yojgfz">
            Clients are responsible for providing accurate, complete, and timely
            information and documentation required for the provision of
            services. Clients must also comply with all applicable laws and
            regulations, including Anti-Money Laundering (AML) and Know Your
            Customer (KYC) requirements.
          </p>

          <h3 data-id="element-531" data-mp="5jxx7x4h6u79">6. Fees, Invoicing, and Refunds</h3>
          <p data-id="element-532" data-mp="alwyn1gnnh1k">
            Fees for our services are agreed upon in advance. Invoices are due
            upon receipt unless otherwise specified. Refunds are subject to our
            refund policy and the policies of relevant government authorities.
            Government fees paid on behalf of the client are generally
            non-refundable.
          </p>

          <h3 data-id="element-533" data-mp="394yd3negtmn7">7. Confidentiality</h3>
          <p data-id="element-534" data-mp="396026vsbg9nx">
            We are committed to maintaining the confidentiality of client
            information. We will not disclose confidential information to third
            parties except as required for the provision of services (e.g., to
            government authorities) or as required by law.
          </p>

          <h3 data-id="element-535" data-mp="vezmcw15n5q">8. Intellectual Property</h3>
          <p data-id="element-536" data-mp="3s3u4ys2upoxv">
            All content on this website, including text, graphics, logos, and
            software, is the property of Brixen Consulting FZCO and is protected
            by intellectual property laws.
          </p>

          <h3 data-id="element-537" data-mp="5p14vjzv6ori">9. Limitation of Liability</h3>
          <p data-id="element-538" data-mp="5qc6pe9r1mfz">
            To the fullest extent permitted by law, Brixen Consulting FZCO shall
            not be liable for any indirect, incidental, special, or
            consequential damages arising out of or in connection with the use
            of our services or website.
          </p>

          <h3 data-id="element-539" data-mp="2931zdqf6mnjr">10. Indemnification</h3>
          <p data-id="element-540" data-mp="2e366ipu7a5xb">
            You agree to indemnify and hold harmless Brixen Consulting FZCO, its
            officers, directors, and employees from any claims, damages,
            liabilities, and expenses arising out of your use of our services or
            violation of these Terms.
          </p>

          <h3 data-id="element-541" data-mp="1q6sf2ldot0rb">11. Governing Law</h3>
          <p data-id="element-542" data-mp="1q7v2ukfpqn30">
            These Terms and Conditions shall be governed by and construed in
            accordance with the laws of the Emirate of Dubai and the Federal
            Laws of the United Arab Emirates.
          </p>

          <h3 data-id="element-543" data-mp="245s1rnhn35ku">12. Changes to Terms</h3>
          <p data-id="element-544" data-mp="246urhs3871z6">
            We reserve the right to modify these Terms and Conditions at any
            time. Changes will be effective immediately upon posting on the
            website.
          </p>

          <h3 data-id="element-545" data-mp="3fjx9mrkz3zlg">13. Contact Information</h3>
          <p data-id="element-546" data-mp="3fn1hbyxnddgv">
            For any questions regarding these Terms, please contact us at:
            <br data-id="element-547" data-mp="3po3z3w9hx7j1" />
            <strong data-id="element-548" data-mp="3pqq5hsknhgzo">Email:</strong> info@brixenconsulting.com
            <br data-id="element-549" data-mp="3kqc4uvldp9bo" />
            <strong data-id="element-550" data-mp="3kqkf0fq4a0j6">Address:</strong> Iris Bay Tower, 2204, Business Bay,
            Dubai, UAE
          </p>
        </div>
      </div>
    </div>;
}